export default "__VITE_PUBLIC_ASSET__4771e371__"